function stripHtml(html) {
  return String(html || '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function looksLikeHtml(value) {
  return /<[a-z][\s\S]*>/i.test(String(value || ''));
}

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function sanitizeProductDescriptionHtml(html) {
  const allowedTags = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'UL', 'OL', 'LI']);
  const template = document.createElement('template');
  template.innerHTML = String(html || '');

  const sanitizeNode = (node) => {
    Array.from(node.childNodes).forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        return;
      }

      if (child.nodeType !== Node.ELEMENT_NODE) {
        child.remove();
        return;
      }

      const el = child;
      const tag = el.tagName;

      if (!allowedTags.has(tag)) {
        while (el.firstChild) {
          el.parentNode.insertBefore(el.firstChild, el);
        }
        el.remove();
        return;
      }

      Array.from(el.attributes).forEach((attr) => attr.remove());
      sanitizeNode(el);
    });
  };

  sanitizeNode(template.content);
  return template.innerHTML;
}

export function formatProductDescription(description) {
  if (!description) {
    return { __html: '' };
  }

  if (looksLikeHtml(description)) {
    return { __html: sanitizeProductDescriptionHtml(description) };
  }

  const escaped = escapeHtml(description).replace(/\n/g, '<br />');
  return { __html: escaped };
}

export function hasProductDescription(description) {
  return looksLikeHtml(description) ? stripHtml(description).length > 0 : Boolean(String(description || '').trim());
}
